import { Controller } from "@hotwired/stimulus"

// Controller genérico para file upload con feedback visual.
// Muestra el nombre del archivo seleccionado en un target label y,
// opcionalmente, valida el tamaño máximo ANTES de subir (File API),
// evitando el 413 de Cloudflare.
//
// Uso básico (solo label):
//   <div data-controller="manage--file-upload">
//     <div data-manage--file-upload-target="label">Seleccionar archivo</div>
//     <input type="file" data-manage--file-upload-target="input"
//            data-action="change->manage--file-upload#select" class="hidden">
//   </div>
//
// Uso con validación de tamaño (max-size-value en bytes):
//   <div data-controller="manage--file-upload"
//        data-manage--file-upload-max-size-value="104857600"
//        data-manage--file-upload-error-message-value="El archivo supera el máximo de 100 MB">
//     <input type="file" data-manage--file-upload-target="input"
//            data-action="change->manage--file-upload#select">
//     <p data-manage--file-upload-target="error" class="hidden"></p>
//     <button data-manage--file-upload-target="submit">Subir</button>
//   </div>
export default class extends Controller {
  static targets = ["label", "input", "error", "submit"]
  static values = {
    placeholder: { type: String, default: "Seleccionar archivo" },
    maxSize: { type: Number, default: 0 },
    errorMessage: { type: String, default: "" }
  }

  select() {
    const file = this.inputTarget.files[0]

    if (this.hasLabelTarget) {
      this.labelTarget.textContent = file ? file.name : this.placeholderValue
    }

    this.validateSize(file)
  }

  validateSize(file) {
    if (this.maxSizeValue <= 0) return

    const tooLarge = file && file.size > this.maxSizeValue
    this.setError(tooLarge, file)
    this.setSubmitDisabled(tooLarge)
  }

  setError(show, file) {
    if (!this.hasErrorTarget) return
    const message = show
      ? this.errorMessageValue.replace("%{size}", this.formatSize(file.size))
      : ""
    this.errorTarget.textContent = message
    this.errorTarget.classList.toggle("hidden", !show)
  }

  // Formatea bytes a MB/KB (1 MB = 1.048.576 bytes, coherente con el límite mostrado).
  formatSize(bytes) {
    const mb = bytes / 1048576
    if (mb >= 1) return `${mb.toFixed(1)} MB`
    return `${Math.max(1, Math.round(bytes / 1024))} KB`
  }

  setSubmitDisabled(disabled) {
    if (!this.hasSubmitTarget) return
    this.submitTarget.disabled = disabled
    this.submitTarget.classList.toggle("opacity-50", disabled)
    this.submitTarget.classList.toggle("cursor-not-allowed", disabled)
  }
}
